// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"9954fa65","282":"d21c3828"}[chunkId] + ".chunk.css";
};